module.exports = __webpack_public_path__ + "img/banner.bbb69f32.png";